<header>
  <div class="label-logo">
    @if (s.currentStep() > 0 && s.stepsLength > 0) {
      <h2>{{ s.currentStep() + '.  ' + (s.currentLabel() | translate) }}</h2>
    }
    <img ngSrc="images/papin-rent-a-bike-logo.png" alt="PapinSport logo" width="746" height="246" priority>
  </div>
  <app-spacer/>
  @if (s.currentStep() > 0 && s.stepsLength > 0 && s.currentStep() < s.stepsLength) {
    <div class="stepper-container clean">
      <kendo-chunkprogressbar
        [chunkCount]="s.stepsLength"
        [value]="s.currentStep() / s.stepsLength * 100">
      </kendo-chunkprogressbar>
      </div>
    <app-spacer/>
  }
</header>
